import { useState } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import "react-pdf/dist/Page/TextLayer.css"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString()

interface IEnkPdfViewerProps {
  pdfData: string | ArrayBuffer
}

export default function EnkPdfViewer(props: IEnkPdfViewerProps) {
  const { pdfData } = props

  const [numPages, setNumPages] = useState<number>(0)

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages)
  }

  return (
    <div className="flex -mx-4 bg-gray-200 items-center justify-center gap-x-6 py-5 overflow-auto">
      {pdfData && (
        <div>
          <Document file={pdfData} onLoadSuccess={onDocumentLoadSuccess} className="my-5 space-y-5">
            {Array.from({ length: numPages }, (_, i) => (
              <>
                <div className="hidden md:block">
                  <Page key={i + 1} pageNumber={i + 1} scale={1} />
                </div>
                <div className="md:hidden">
                  <Page key={i + 1} pageNumber={i + 1} scale={0.6} />
                </div>
              </>
            ))}
          </Document>
        </div>
      )}
    </div>
  )
}
